import ApiService from "../ApiService";

const { REACT_APP_REST_ENDPOINT } = process.env;

/**
 * SafetyUtentiBridgeService
 * Client API per il ponte LMS ↔ Safety: ricerca candidati di utenti
 * eduform da collegare a un nuovo lavoratore safety.
 */
export default class SafetyUtentiBridgeService {
    /**
     * Cerca candidati di match. Almeno UNO tra:
     *   - email (match esatto)
     *   - codice_fiscale (match esatto)
     *   - nome + cognome + data_nascita (tutti e 3)
     *
     * Ritorna max 20 candidati con flag already_linked se sono già
     * collegati a un altro safety_lavoratore.
     */
    static matchCandidates = (filtri) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/utenti-bridge/matchCandidates`;
            ApiService.postRequest(resolve, reject, url, filtri || {});
        });
    };

    /**
     * Elenco dei corsisti dell'agenzia (con almeno un corso eduform)
     * importabili come lavoratori safety. id_agenzia opzionale (usato solo
     * da admin/superpartner: i ruoli agenzia usano sempre la propria).
     */
    static listCorsisti = (id_agenzia) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/safety/utenti-bridge/corsisti`;
            const payload = id_agenzia ? { id_agenzia } : {};
            ApiService.postRequest(resolve, reject, url, payload);
        });
    };
}
